import { createRoot, IReactRoot } from '@aytm/lib/common/reactCreateRoot'

import TooltipHost from '@aytm/app/stats/components/tooltip/TooltipHost'

export { default as Tooltip, TOOLTIP_TONE } from '@aytm/app/stats/components/tooltip/Tooltip'

const HOST_ID = 'stats-tooltip'

let root: IReactRoot | null = null

// A root of its own on the body. The live report has no single React tree to hang this from -- the
// older page driver mounts a root per block -- and the pill has to outlive whichever of those is
// being redrawn under the pointer.
export function mountTooltips() {
  if (root || document.querySelector(`#${HOST_ID}`)) return

  const host = document.createElement('div')
  host.id = HOST_ID
  document.body.appendChild(host)

  root = createRoot(host)
  root.render(<TooltipHost />)
}

export function unmountTooltips() {
  root?.unmount()
  root = null
  document.querySelector(`#${HOST_ID}`)?.remove()
}
